import { useState } from "react";
import { Play } from "lucide-react";
import { YOUTUBE_ID, YOUTUBE_URL, PSALM } from "../lib/content";
import { FadeUp, MaskReveal } from "./Reveal";

export default function Music() {
  const [playing, setPlaying] = useState(false);

  return (
    <section
      id="music"
      data-testid="music-section"
      className="relative bg-[var(--bg)] px-6 md:px-12 py-28 md:py-44"
    >
      <div className="mx-auto max-w-[1500px]">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
          <div>
            <FadeUp className="mb-6 flex items-center gap-6">
              <span className="h-px w-12 bg-[var(--gold)]" />
              <span className="font-mono text-[11px] tracking-[0.35em] text-[var(--gold-ink)] uppercase">
                Μουσική / Βίντεο
              </span>
            </FadeUp>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-7xl leading-[1.02] text-[var(--fg)]">
              <MaskReveal>Άκου το</MaskReveal>
              <MaskReveal delay={0.08} className="italic text-[var(--gold-ink)]">
                ταξίδι μας.
              </MaskReveal>
            </h2>
          </div>
          <FadeUp delay={0.15}>
            <a
              data-testid="youtube-external"
              href={YOUTUBE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-[11px] tracking-[0.25em] uppercase text-[var(--muted)] hover:text-[var(--gold-ink)] link-underline transition-colors duration-300"
            >
              Άνοιξε στο YouTube ↗
            </a>
          </FadeUp>
        </div>

        <FadeUp y={60} className="relative">
          {/* golden glow backdrop */}
          <div className="pointer-events-none absolute -inset-6 md:-inset-12 rounded-full bg-[var(--gold)]/10 blur-3xl" />
          <div className="relative aspect-video w-full overflow-hidden rounded-sm ring-1 ring-[var(--line-gold)]">
            {playing ? (
              <iframe
                data-testid="youtube-iframe"
                className="h-full w-full"
                src={`https://www.youtube.com/embed/${YOUTUBE_ID}?autoplay=1&rel=0`}
                title="ΤΑΞΙΔΙΩΤΕΣ — Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : (
              <button
                data-testid="video-play-button"
                onClick={() => setPlaying(true)}
                className="group relative h-full w-full"
              >
                <img
                  src={`https://img.youtube.com/vi/${YOUTUBE_ID}/hqdefault.jpg`}
                  onError={(e) => {
                    e.currentTarget.src = `https://img.youtube.com/vi/${YOUTUBE_ID}/0.jpg`;
                  }}
                  alt="ΤΑΞΙΔΙΩΤΕΣ video"
                  className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
                />
                <span className="absolute inset-0 bg-[#0a0a0c]/35 transition-colors duration-500 group-hover:bg-[#0a0a0c]/20" />
                <span className="absolute left-1/2 top-1/2 flex h-20 w-20 md:h-28 md:w-28 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-[var(--gold)] bg-[#0a0a0c]/45 backdrop-blur-sm text-[var(--gold)] transition-[background-color,color,transform] duration-500 group-hover:bg-[var(--gold)] group-hover:text-[#1a1814] group-hover:scale-110">
                  <Play className="ml-1" size={30} fill="currentColor" />
                </span>
                <span className="absolute bottom-6 left-6 font-mono text-[11px] tracking-[0.3em] uppercase text-white drop-shadow-[0_1px_6px_rgba(10,10,12,0.6)]">
                  ▶ Live Worship
                </span>
              </button>
            )}
          </div>
        </FadeUp>

        {/* Psalm 150 strip */}
        <div className="mt-24 md:mt-36 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <FadeUp className="md:col-span-3">
            <span className="font-mono text-[11px] tracking-[0.35em] text-[var(--gold-ink)] uppercase">
              Ψαλμός 150
            </span>
          </FadeUp>
          <div className="md:col-span-9 space-y-3">
            {PSALM.map((line, i) => (
              <MaskReveal
                key={i}
                delay={i * 0.05}
                className="font-serif text-2xl md:text-4xl leading-tight text-[var(--fg)]"
              >
                {line}
              </MaskReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
